import type { CommodityInfo } from '@/gen/open-api-docs/CoolPlan2nd/components/schemas';

export enum UserIdentifyInfo {
    SUCCESS = 1,
    RECEIVED = 2,
    IDENTITY_NOT_MATCH = 3,
    COUPON_NOT_SUFFICIENT = 4,
    USER_IDENTIFICATION_ERROR = 5,
    COUPON_EXPIRE = 6,
}

export enum RedPacketEnum {
    NOT_LOGIN = 1, // 未登录提示可领红包
    NOT_RECEIVED = 2, // 未领取红包挽留
    HAS_RECEIVED = 3, // 已领取红包跳转商详
    NEW_USER_COUPON = 4, // 新用户红包
    NEW_USER_RECEIVED = 5, // 新用户成功领取红包
}

export enum LocalStorageKeyEnum {
    /**
     * 挽留弹窗弹出次数
     */
    STAY_MODAL_FREQUENCY_COUNT = 'STAY_MODAL_FREQUENCY_COUNT',
    /**
     * 挽留弹窗弹出时间
     */
    STAY_MODAL_FREQUENCY_DATE = 'STAY_MODAL_FREQUENCY_DATA',
    /**
     * 新人弹窗弹出次数
     */
    NEW_USER_MODAL_FREQUENCY_COUNT = 'NEW_USER_MODAL_FREQUENCY_COUNT',
}

export enum OrderSourceEnum {
    COOL_PLAN_BANNER = '1',
    COOL_PLAN_AD_CHANNEL = '2',
    DOUBLE_ELEVEN = '104',
    CHABAIDAO = '300',
    KEHAOCHAOSHI = '301',
}

export interface MarqueeItem {
    text: string;
}

export interface CommodityInfoWithIndex extends CommodityInfo {
    index?: number;
}
export enum CouponStatusEnum {
    // 优惠券状态，2-已领取，4-抢光，100-可领取，101-不可领取
    RECEIVED = 2,
    EMPTY = 4,
    CAN_RECEIVE = 100,
    CANNOT_RECEIVE = 101,
}
